import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p>copyright @guimaraesalves2021</p>
      <div className="social">
        <i className="fa fa-facebook"></i>
        <i className="fa fa-instagram"></i>
      </div>
    </div>
  );
}

export default Footer;
